import React from 'react';
import { Grid } from '@mui/material';
import { StyledTextField } from '../../tiered-unit-count/styledComponents';
import { ISubscriptionData } from '../types';
import {
  shouldPulse,
  getFieldAnimationStyles,
  getRequiredFieldPulseStyles,
} from '../animationStyles';

interface ISubscriptionInvoiceFieldsProps {
  subscriptionData: ISubscriptionData;
  setSubscriptionData: React.Dispatch<React.SetStateAction<ISubscriptionData>>;
}

export const SubscriptionInvoiceFields: React.FC<ISubscriptionInvoiceFieldsProps> = ({
  subscriptionData,
  setSubscriptionData,
}) => {
  const isInvoiceDescriptionEmpty = shouldPulse(subscriptionData.invoiceDescription, true);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <StyledTextField
            hasErrors={subscriptionData.invoiceDescription.trim().length === 0}
            label="Invoice Description *"
            type="text"
            size="small"
            fullWidth
            className={isInvoiceDescriptionEmpty ? 'required-empty' : ''}
            sx={{
              backgroundColor: "white",
              ...getFieldAnimationStyles(),
              ...(isInvoiceDescriptionEmpty && getRequiredFieldPulseStyles()),
            }}
            value={subscriptionData.invoiceDescription}
            onChange={(e) => {
              setSubscriptionData((old) => ({ ...old, invoiceDescription: e.target.value }));
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};
